
const project   = "OKULCANTAM";

const config    = {
    "DEVELOP" : {
        "apiBaseUrl"  : "https://www.mbyvz.com/projects/schoolB2C/api/",
        "appBaseUrl"  : "/projects/schoolB2C/"
    },
    "OKULSATIS" : {
        "apiBaseUrl"  : "https://www.okulsatis.com/api/",
        "appBaseUrl"  : "/"
    },
    "OKULCANTAM" : {
        "apiBaseUrl"  : "https://www.okulcantam.com/api/",
        "appBaseUrl"  : "/"
    },
    "GUNESOKUL" : {
        "apiBaseUrl"  : "https://www.gunesokul.com/api/",
        "appBaseUrl"  : "/"
    },
    "MELODIKITAP" : {
        "apiBaseUrl"  : "https://www.melodikitap.com/api/",
        "appBaseUrl"  : "/"
    },
    "ERSEONLINE" : {
        "apiBaseUrl"  : (typeof window !== "undefined" ? window.location.origin : "")+"/api/",
        "appBaseUrl"  : "/"
    },
    "OKULKAYIT" : {
        "apiBaseUrl"  : (typeof window !== "undefined" ? window.location.origin : "")+"/api/",
        "appBaseUrl"  : "/"
    },
    "UTKUOKUL" : {
        "apiBaseUrl"  : "https://www.utkuokul.com/api/",
        "appBaseUrl"  : "/"
    },
    "ARTIOKUL" : {
        "apiBaseUrl"  : "https://www.artiokul.com/api/",
        "appBaseUrl"  : "/"
    },
};





module.exports = config[project];